import { render, staticRenderFns } from "./PostOptionPreview.vue?vue&type=template&id=5ba0985c&scoped=true&lang=pug&"
import script from "./PostOptionPreview.vue?vue&type=script&lang=js&"
export * from "./PostOptionPreview.vue?vue&type=script&lang=js&"
import style0 from "./PostOptionPreview.vue?vue&type=style&index=0&id=5ba0985c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba0985c",
  null
  
)

export default component.exports